import { Component, input, output, effect, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Global } from '@services/core/Global';
import { FormMode } from 'app/core/constants/form-mode';
import { DocumentUploadComponent } from '../document-upload/document-upload.component';

@Component({
  selector: 'app-vehicle-document',
  standalone: true,
  imports: [CommonModule, FormsModule, DocumentUploadComponent],
  templateUrl: './vehicle-document.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./vehicle-document.component.css']
})
export class VehicleDocumentComponent {
  vehicles = input.required<any[]>();
  documents = input.required<any>();
  mode = input(FormMode.EDIT);

  onDocumentUpdate = output<void>();
  onViewImage = output<string | number>();

  selectedVehicleUuid = signal<string | null>(null);

  formMode = FormMode;
  globalUrl = Global.url;

  constructor() {
    // Al cambiar de socio/lista: si el uuid seleccionado ya no está, tomar el primero válido
    effect(() => {
      const list = this.vehicles() ?? [];
      const validVehicles = list.filter((v) => this.isVehicleValid(v));
      const current = this.selectedVehicleUuid();
      const stillValid = !!current && validVehicles.some((v) => v.uuid === current);
      if (!stillValid) {
        this.selectedVehicleUuid.set(validVehicles[0]?.uuid ?? null);
      }
    });
  }

  // Valida si un vehículo es elegible para gestionar documentación
  isVehicleValid(v: any): boolean {
    return Boolean(v && !['INACTIVE', 'REJECTED'].includes(v.statusSlug));
  }

  selectVehicle(uuid: string) {
    this.selectedVehicleUuid.set(uuid);
  }

  hasActiveVehicles(): boolean {
    const list = this.vehicles() ?? [];
    return list.some((v) => this.isVehicleValid(v));
  }

  getActiveVehiclesCount(): number {
    const list = this.vehicles() ?? [];
    return list.filter((v) => this.isVehicleValid(v)).length;
  }

  // Devuelve las categorías con documentos filtrados del vehículo seleccionado
  getFilteredVehicleDocs(): any[] {
    const cats = this.documents()?.categories ?? [];
    return cats
      .map((c) => this._filterCatDocs(c))
      .filter((c) => c.documents.length > 0);
  }

  private _filterCatDocs(c: any): any {
    const selUuid = this.selectedVehicleUuid();
    const docs = (c.documents ?? []).filter((d: any) => d.vehicleUuid === selUuid);
    return { ...c, documents: docs };
  }

  // Abre el visor en el padre (imágenes y PDF)
  openViewer(clickedId?: string | number) {
    if (clickedId) this.onViewImage.emit(clickedId);
  }
}
